var map = {
	"./vp/assistance.newtask.svg": 3730,
	"./vp/bg.authcols.svg": 9885,
	"./vp/bg.authcols.title.svg": 6673,
	"./vp/bg.gift.instructions.png": 9502,
	"./vp/bg.heart.blue.png": 1647,
	"./vp/bg.heart.red.png": 862,
	"./vp/bg.heart2.red.png": 6588,
	"./vp/bg.rightcol.png": 381,
	"./vp/bg.task.heart.svg": 919,
	"./vp/dobro.logo.svg": 2340,
	"./vp/header.phone.png": 9719,
	"./vp/headerimg.desk.jpg": 5151,
	"./vp/headerimg.mobi.jpg": 3075,
	"./vp/icon.addfriend.white.svg": 8744,
	"./vp/icon.addtask.black.svg": 7649,
	"./vp/icon.addtask.red.svg": 6725,
	"./vp/icon.addtask.white.svg": 2759,
	"./vp/icon.arrow.left.gray.svg": 1007,
	"./vp/icon.arrow.right.gray.svg": 6942,
	"./vp/icon.award.gray.svg": 8026,
	"./vp/icon.award.red.svg": 640,
	"./vp/icon.burgerdots.red.svg": 6288,
	"./vp/icon.burgerdots.white.svg": 5246,
	"./vp/icon.camera.white.svg": 5368,
	"./vp/icon.checkbox.off.gray.svg": 2013,
	"./vp/icon.checkbox.on.red.svg": 8383,
	"./vp/icon.checkin.red.svg": 4546,
	"./vp/icon.chevrondown.svg": 6865,
	"./vp/icon.city.red.svg": 1354,
	"./vp/icon.close.black.svg": 4431,
	"./vp/icon.comment.outline.black.svg": 6696,
	"./vp/icon.copy.svg": 4619,
	"./vp/icon.delete.black.svg": 4206,
	"./vp/icon.delete.gray.svg": 8640,
	"./vp/icon.delete.outline.black.svg": 7830,
	"./vp/icon.delete.red.svg": 294,
	"./vp/icon.deletebutton.red.svg": 278,
	"./vp/icon.dobrobook.gray.svg": 6740,
	"./vp/icon.dobrobook.linked.svg": 982,
	"./vp/icon.dobrobook.pending.svg": 5842,
	"./vp/icon.dobrobook.red.svg": 4186,
	"./vp/icon.dobrobook.unlinked.svg": 2531,
	"./vp/icon.document.red.svg": 56,
	"./vp/icon.document.white.svg": 5158,
	"./vp/icon.download.red.svg": 1967,
	"./vp/icon.download.white.svg": 8697,
	"./vp/icon.download2.red.svg": 9121,
	"./vp/icon.dropdown.black.svg": 4996,
	"./vp/icon.dropdown.white.svg": 7874,
	"./vp/icon.edit.black.svg": 679,
	"./vp/icon.edit.outline.black.svg": 5067,
	"./vp/icon.event.svg": 1172,
	"./vp/icon.events.svg": 3455,
	"./vp/icon.fb.red.png": 7968,
	"./vp/icon.fb.white.png": 4606,
	"./vp/icon.filter.red.svg": 3077,
	"./vp/icon.filter.svg": 9402,
	"./vp/icon.filter.white.svg": 3607,
	"./vp/icon.geo.red.svg": 8956,
	"./vp/icon.gifts.svg": 4905,
	"./vp/icon.heart.darkred.svg": 8055,
	"./vp/icon.heart.red.svg": 7107,
	"./vp/icon.heart.svg": 5600,
	"./vp/icon.heart.white.svg": 4245,
	"./vp/icon.hours.gray.png": 4387,
	"./vp/icon.hours.red.png": 9925,
	"./vp/icon.hours.white.svg": 432,
	"./vp/icon.in.red.png": 5861,
	"./vp/icon.in.white.png": 3919,
	"./vp/icon.index.organizations.svg": 334,
	"./vp/icon.info.black.svg": 5471,
	"./vp/icon.leftarrow2.black.svg": 7011,
	"./vp/icon.leftarrow2.blue.svg": 8770,
	"./vp/icon.leftarrow2.darkblue.svg": 1934,
	"./vp/icon.leftarrow2.red.svg": 9551,
	"./vp/icon.leftarrow2.white.svg": 6953,
	"./vp/icon.linked.png": 1544,
	"./vp/icon.logo.mainslider.svg": 1433,
	"./vp/icon.mail.black.svg": 4586,
	"./vp/icon.mail.red.svg": 9741,
	"./vp/icon.mail.white.svg": 7936,
	"./vp/icon.menu.events.black.svg": 7733,
	"./vp/icon.menu.events.red.svg": 65,
	"./vp/icon.menu.gift.gray.svg": 4214,
	"./vp/icon.menu.gift.red.svg": 8508,
	"./vp/icon.menu.help.black.svg": 7171,
	"./vp/icon.menu.help.red.svg": 5439,
	"./vp/icon.menu.help2.black.svg": 5749,
	"./vp/icon.menu.help2.red.svg": 3185,
	"./vp/icon.menu.info.black.svg": 4634,
	"./vp/icon.menu.info.red.svg": 8602,
	"./vp/icon.menu.info.white.svg": 6160,
	"./vp/icon.menu.news.black.svg": 3339,
	"./vp/icon.menu.news.red.svg": 8759,
	"./vp/icon.menu.tasks.black.svg": 2382,
	"./vp/icon.menu.tasks.red.svg": 6694,
	"./vp/icon.noaccount.white.svg": 2551,
	"./vp/icon.notifications.black.svg": 1759,
	"./vp/icon.notifications.red.png": 8324,
	"./vp/icon.notifications.red.svg": 6339,
	"./vp/icon.ok.red.png": 6530,
	"./vp/icon.ok.white.png": 8464,
	"./vp/icon.pdf.bg.red.png": 6201,
	"./vp/icon.people.svg": 7741,
	"./vp/icon.personremove.white.svg": 5506,
	"./vp/icon.phone.red.svg": 7915,
	"./vp/icon.profile.tg.red.svg": 8791,
	"./vp/icon.profile.whatsup.red.svg": 2252,
	"./vp/icon.removefriend.white.svg": 7417,
	"./vp/icon.rightarrow.blue.svg": 7289,
	"./vp/icon.rightarrow.gray.svg": 8764,
	"./vp/icon.rightarrow.png": 3246,
	"./vp/icon.rightarrow.red.svg": 4002,
	"./vp/icon.rightarrow.white.svg": 4744,
	"./vp/icon.rightarrow2.black.svg": 4914,
	"./vp/icon.rightarrow2.blue.png": 9214,
	"./vp/icon.rightarrow2.darkblue.svg": 7825,
	"./vp/icon.rightarrow2.lightblue.svg": 4915,
	"./vp/icon.rightarrow2.red.png": 1853,
	"./vp/icon.rightarrow2.red.svg": 6098,
	"./vp/icon.rightarrow2.svg": 153,
	"./vp/icon.rightarrow2.white.svg": 2888,
	"./vp/icon.roof.black.svg": 2805,
	"./vp/icon.rt.red.png": 1134,
	"./vp/icon.rt.white.png": 4516,
	"./vp/icon.search.black.svg": 5407,
	"./vp/icon.search.png": 6335,
	"./vp/icon.search.svg": 4192,
	"./vp/icon.sharebutton.blue.svg": 9117,
	"./vp/icon.sharebutton.png": 3082,
	"./vp/icon.sharebutton.red.svg": 5606,
	"./vp/icon.sharebutton.svg": 9141,
	"./vp/icon.sharebutton.white.svg": 7700,
	"./vp/icon.sliderarrow.svg": 6670,
	"./vp/icon.star.blue.svg": 5314,
	"./vp/icon.star.gray.svg": 911,
	"./vp/icon.star.red.svg": 2927,
	"./vp/icon.statistics.white.svg": 7868,
	"./vp/icon.submenu.edu.black.svg": 5034,
	"./vp/icon.submenu.edu.red.svg": 2346,
	"./vp/icon.submenu.history.black.svg": 3806,
	"./vp/icon.submenu.history.red.svg": 2870,
	"./vp/icon.submenu.organizations.black.svg": 5498,
	"./vp/icon.submenu.organizations.red.svg": 6874,
	"./vp/icon.submenu.polls.black.svg": 9044,
	"./vp/icon.submenu.polls.red.svg": 4108,
	"./vp/icon.submenu.resourcecenters.red.svg": 2456,
	"./vp/icon.submenu.resourcecenters.svg": 5511,
	"./vp/icon.submenu.stats.black.svg": 7075,
	"./vp/icon.submenu.stats.red.svg": 4751,
	"./vp/icon.submenu.supportmeasures.red.svg": 7004,
	"./vp/icon.submenu.supportmeasures.svg": 6803,
	"./vp/icon.submenu.volonters.black.svg": 4174,
	"./vp/icon.submenu.volonters.red.svg": 7897,
	"./vp/icon.switcher.off.png": 4079,
	"./vp/icon.switcher.off.white.png": 26,
	"./vp/icon.switcher.on.png": 1077,
	"./vp/icon.switcher.on.white.png": 9816,
	"./vp/icon.syncing.png": 1124,
	"./vp/icon.task.svg": 5283,
	"./vp/icon.tg.red.png": 5431,
	"./vp/icon.trend.down.svg": 8601,
	"./vp/icon.trend.up.svg": 1158,
	"./vp/icon.tt.red.png": 3264,
	"./vp/icon.tt.white.png": 4846,
	"./vp/icon.url.red.svg": 5808,
	"./vp/icon.user.black.svg": 6742,
	"./vp/icon.verifiedrep.person.svg": 6038,
	"./vp/icon.verifiedrep.shield.svg": 8994,
	"./vp/icon.verifiedrep.svg": 721,
	"./vp/icon.vk.red.png": 6185,
	"./vp/icon.vk.white.png": 7035,
	"./vp/icon.vote.smile-1.svg": 8192,
	"./vp/icon.vote.smile-2.svg": 5235,
	"./vp/icon.vote.smile-3.svg": 594,
	"./vp/icon.vote.star.gray.svg": 7097,
	"./vp/icon.vote.star.red.svg": 2017,
	"./vp/icon.wallet.white.svg": 7794,
	"./vp/icon.yt.red.png": 1427,
	"./vp/icon.yt.white.png": 2197,
	"./vp/logo.svg": 7068,
	"./vp/logo.white.svg": 3857,
	"./vp/mobileapps.android.png": 4031,
	"./vp/mobileapps.android.svg": 720,
	"./vp/mobileapps.ios.svg": 3454,
	"./vp/no.img.png": 7532,
	"./vp/no.map.png": 1347,
	"./vp/no.profile.png": 8842,
	"./vp/parallax.01.1.png": 7131,
	"./vp/parallax.01.2.png": 2096,
	"./vp/parallax.01.3.png": 3273,
	"./vp/parallax.02.1.png": 2284,
	"./vp/parallax.02.2.png": 6567,
	"./vp/parallax.02.3.png": 3550,
	"./vp/parallax.new.01.svg": 5975,
	"./vp/parallax.new.02.svg": 1524,
	"./vp/parallax.new.03.a.svg": 6906,
	"./vp/parallax.new.03.b.svg": 1929,
	"./vp/parallax.new.03.c.svg": 6536,
	"./vp/parallax.new.04.a.svg": 5665,
	"./vp/parallax.new.04.b.svg": 3922,
	"./vp/parallax.new.04.c.svg": 3315,
	"./vp/parallax.new.05.a.svg": 3604,
	"./vp/parallax.new.05.b.svg": 4407,
	"./vp/parallax.new.05.c.svg": 9078,
	"./vp/parallax.new.06.a.svg": 1155,
	"./vp/parallax.new.06.b.svg": 400,
	"./vp/parallax.new.06.c.svg": 8734,
	"./vp/parallax.new.06.d.svg": 7854,
	"./vp/parallax.temp.01.svg": 955,
	"./vp/parallax.temp.02.svg": 507,
	"./vp/parallax.temp.03.svg": 8249,
	"./vp/parallax.temp.04.svg": 8838,
	"./vp/parallax.temp.05.svg": 7815,
	"./vp/sample.course.jpg": 3292,
	"./vp/sample.course2.jpg": 3917,
	"./vp/sample.course3.jpg": 8352,
	"./vp/sample.db.jpg": 8973,
	"./vp/sample.map.png": 308,
	"./vp/sample.practice.jpg": 9751,
	"./vp/sample.practice2.jpg": 4629,
	"./vp/sample.practice3.jpg": 408,
	"./vp/sample.profile.png": 8173,
	"./vp/sample.shishkin.jpg": 9587,
	"./vp/sample.taskimage.jpg": 8424,
	"./vp/sample.taskimagethumb.png": 290,
	"./vp/sample.taskimagethumb_.png": 8687,
	"./vp/samples/01.jpg": 9263,
	"./vp/samples/02.jpg": 4304,
	"./vp/samples/03.jpg": 1405,
	"./vp/samples/04.jpg": 8054,
	"./vp/samples/05.jpg": 9107,
	"./vp/samples/06.jpg": 7300,
	"./vp/samples/07.jpg": 5825,
	"./vp/samples/08.jpg": 6298,
	"./vp/samples/09.png": 55,
	"./vp/samples/10.jpg": 2777,
	"./vp/samples/11.jpg": 1724,
	"./vp/samples/12.jpg": 3707,
	"./vp/samples/13.jpg": 5662,
	"./vp/samples/14.jpg": 8133,
	"./vp/samples/15.jpg": 264,
	"./vp/samples/16.jpg": 7719,
	"./vp/samples/17.jpg": 1882,
	"./vp/samples/18.jpg": 2993,
	"./vp/samples/19.jpg": 8660,
	"./vp/samples/20.jpg": 1752,
	"./vp/samples/21.jpg": 4117,
	"./vp/samples/22.jpg": 1514,
	"./vp/samples/23.jpg": 8356,
	"./vp/samples/24.jpg": 9247,
	"./vp/samples/25.jpg": 3353,
	"./vp/samples/26.jpg": 3294,
	"./vp/samples/27.jpg": 4427,
	"./vp/samples/28.jpg": 8960,
	"./vp/slider.index.01.jpg": 3924,
	"./vp/slider.index.02.jpg": 8403,
	"./vp/slider.index.03.jpg": 9878,
	"./vp/slider.index.04.jpg": 1325,
	"./vp/slider.index.05.jpg": 6752,
	"./vp/slider.index.forum.jpg": 514,
	"./vp/slider.index.perepis.jpg": 2259,
	"./vp/tutorialpopup.1.svg": 6579,
	"./vp/tutorialpopup.2.svg": 9859,
	"./vp/tutorialpopup.3.svg": 7218,
	"./vp/tutorialpopup.4.svg": 5533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;